import PropTypes from 'prop-types';
import TableCell from '@mui/material/TableCell';
import { isEmpty } from 'ramda';

import { PKUrl } from 'components';
import { equalOrThreeDashes } from 'utils';

export const ServicesListRow = ({ communication }) => {
	const { serviceName, policyNo, activityName, resultActivityName, products = [] } = communication;

	return (
		<>
			<TableCell>{equalOrThreeDashes(serviceName)}</TableCell>
			<PKUrl.PKPolicy policyNo={policyNo}>
				<TableCell>{equalOrThreeDashes(policyNo)}</TableCell>
			</PKUrl.PKPolicy>
			<TableCell>
				{!isEmpty(products) ? products.map((product, i) => <div key={i}>{product.longName}</div>) : '---'}
			</TableCell>
			<TableCell>{equalOrThreeDashes(activityName)}</TableCell>
			<TableCell>{equalOrThreeDashes(resultActivityName)}</TableCell>
		</>
	);
};

ServicesListRow.propTypes = {
	communication: PropTypes.object,
};

export default ServicesListRow;
